import { Controller } from 'react-hook-form';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Label, Input } from '@/shared/components';

interface Props<TInput extends FieldValues, TOutput extends FieldValues> {
    control: Control<TInput, unknown, TOutput>;
    derivativeSelected: boolean;
    busy: boolean;
}

export const PlanVehicleRuleAgeFields = <TInput extends FieldValues, TOutput extends FieldValues>({
    control,
    derivativeSelected,
    busy,
}: Props<TInput, TOutput>) => (
    <div className="grid grid-cols-2 gap-3">
        <div>
            <Label htmlFor="pvr_age_min">
                Age min (yrs) <span className="text-mp-muted">(optional)</span>
            </Label>
            <Controller
                name={'age_min' as Path<TInput>}
                control={control}
                render={({ field, fieldState: { error: fieldError } }) => (
                    <Input
                        id="pvr_age_min"
                        type="number"
                        min="0"
                        placeholder="Any"
                        disabled={busy || derivativeSelected}
                        value={(field.value as string | number | undefined) ?? ''}
                        onChange={(e) => field.onChange(e.target.value)}
                        onBlur={field.onBlur}
                        error={!!fieldError}
                        hint={fieldError?.message}
                    />
                )}
            />
        </div>

        <div>
            <Label htmlFor="pvr_age_max">
                Age max (yrs) <span className="text-mp-muted">(optional)</span>
            </Label>
            <Controller
                name={'age_max' as Path<TInput>}
                control={control}
                render={({ field, fieldState: { error: fieldError } }) => (
                    <Input
                        id="pvr_age_max"
                        type="number"
                        min="0"
                        placeholder="Any"
                        disabled={busy || derivativeSelected}
                        value={(field.value as string | number | undefined) ?? ''}
                        onChange={(e) => field.onChange(e.target.value)}
                        onBlur={field.onBlur}
                        error={!!fieldError}
                        hint={fieldError?.message}
                    />
                )}
            />
        </div>
    </div>
);
